import { IconButton, TableBody, TableCell } from '@material-ui/core'
import React from 'react'
import CustomTable from '../Table/CustomTable'
import CustomTableHeading from '../Table/CustomTableHeading'
import CustomTableRow from '../Table/CustomTableRow'
import ActionIcon2 from '../ActionIcon2'

import CustomDialog from '../CustomDialog'
import { ZonesCatalogue } from '../Forms/Zones/ZonesCatalogue'
import CustomButton from '../CustomButton'
import { BiPlusCircle } from 'react-icons/bi'

export const BusinessZones = () => {
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  // const {zones}

  const handleEditOpen = () => {}
  const handleDeleteOpen = () => {}
  return (
    <div>
      {/* <button style={{ float: 'right', margin: 5 }} onClick={handleOpen}>
        +
      </button> */}

      <IconButton onClick={handleOpen} style={{ float: 'right' }} color="primary">
        <BiPlusCircle />
      </IconButton>
      <CustomTable>
        <CustomTableHeading heading={['Zone', 'Action']} />
        <TableBody>
          <CustomTableRow>
            {/* <TableCell>East</TableCell>
            <TableCell>
              <ActionIcon2 dialog1={handleEditOpen} dialog2={handleDeleteOpen} />
            </TableCell>
          </CustomTableRow>
          <CustomTableRow>
            <TableCell>North</TableCell>
            <TableCell>
              <ActionIcon2 dialog1={handleEditOpen} dialog2={handleDeleteOpen} />
            </TableCell>
          </CustomTableRow>
          <CustomTableRow>
            <TableCell>West</TableCell>
            <TableCell>
              <ActionIcon2 dialog1={handleEditOpen} dialog2={handleDeleteOpen} />
            </TableCell>
          </CustomTableRow>
          <CustomTableRow>
            <TableCell>South</TableCell>
            <TableCell>
              <ActionIcon2 dialog1={handleEditOpen} dialog2={handleDeleteOpen} />
            </TableCell> */}
          </CustomTableRow>
        </TableBody>
      </CustomTable>

      <CustomDialog open={open} handleClose={handleClose}>
        <ZonesCatalogue handleClose={handleClose} />
      </CustomDialog>
    </div>
  )
}
